module.exports = __webpack_public_path__ + "static/media/training.1a30ac27.svg";